<!-- wyf 2022-3-1 -->
<template>
  <a-menu-divider />
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ZMenuDivider'
})
</script>
